import type { ComponentProps } from "react"

export default function AddTag(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M14.2875 9.06877L15 8.00002L12.15 3.72502C12.1048 3.65531 12.0427 3.59814 11.9695 3.55881C11.8963 3.51948 11.8143 3.49926 11.7312 3.50002H2.5C2.36739 3.50002 2.24021 3.5527 2.14645 3.64647C2.05268 3.74024 2 3.86741 2 4.00002V12C2 12.1326 2.05268 12.2598 2.14645 12.3536C2.24021 12.4473 2.36739 12.5 2.5 12.5H8.33333"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 9.33325V13.3333"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 11.3333H10"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
